import { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { LuArrowLeft, LuMailCheck } from 'react-icons/lu';
import { AuthLayout } from '../../app/AuthLayout';
import { Button } from '../../ui/Button';
import { Field, Input } from '../../ui/Form';
import { Alert, EmptyState } from '../../ui/Feedback';
import { useDocumentTitle, useStrings, useTenant } from '../../tenant/TenantProvider';
import { apiRequest } from '../../lib/api';

export function ForgotPasswordPage() {
  const t = useStrings();
  const { features } = useTenant();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  useDocumentTitle(t('auth.forgotTitle'));
  if (features.forgotPassword === false) return <Navigate to="/login" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    const response = await apiRequest('/auth/v2/forgot-password', { method: 'POST', body: { email } });
    setSubmitting(false);
    if (response.success) setSent(true);
    else setError(response.error);
  };

  const back = (
    <Link to="/login" className="text-link back-to-login">
      <LuArrowLeft aria-hidden="true" />
      {t('auth.backToSignIn')}
    </Link>
  );

  if (sent) {
    return (
      <AuthLayout title={t('auth.forgotSentTitle')} footer={back}>
        <EmptyState icon={LuMailCheck} title={t('auth.forgotSentText', { email })} className="auth__sent" />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={t('auth.forgotTitle')} subtitle={t('auth.forgotText')} footer={back}>
      {error && <Alert tone="danger">{error}</Alert>}
      <form className="auth__form" onSubmit={submit} noValidate>
        <Field label={t('auth.email')} htmlFor="forgot-email">
          <Input id="forgot-email" type="email" size="lg" autoComplete="email" autoFocus required value={email} onChange={(event) => setEmail(event.target.value)} />
        </Field>
        <Button type="submit" variant="primary" size="lg" block loading={submitting} disabled={!email}>
          {submitting ? t('auth.sendingLink') : t('auth.sendLink')}
        </Button>
      </form>
    </AuthLayout>
  );
}
